import DsAuthPrimaryTokenServiceBase from './DsAuthPrimaryTokenServiceBase';
import SecondaryTokenServiceBase from './SecondaryTokenServiceBase';
import CloudPrimaryTokenService from './CloudPrimaryTokenService';
import CloudSecondaryTokenService from './CloudSecondaryTokenService';
import { config } from '../AuthConfig';
import AuthMan from '../AuthMan';
import { NetworkLocation, StoreType } from '../TypeDefinitions';
import OnPremSecondaryTokenService from './OnPremSecondaryTokenService';
import OnPremPrimaryTokenService from './OnPremPrimaryTokenService';
import NetworkLocationHandler from '../beacon/NetworkLocationHandler';

export default class TokenServiceFactory {
	static getPrimaryTokenServiceInstance(
		referenceUri: string
	): DsAuthPrimaryTokenServiceBase {
		if (!config.isUnifiedAuthenticationEnabled) {
			return CloudPrimaryTokenService.getInstance();
		} else {
			const storeConfig = AuthMan.getInstance().getStoreConfiguration();

			let networkLocation: NetworkLocation;
			if (config.isSimplifyBeaconLogicEnabled) {
				networkLocation =
					NetworkLocationHandler.getInstance().GetNetworkLocationFromCache(referenceUri);
			} else {
				networkLocation = storeConfig[referenceUri].networkLocation;
			}

			if (storeConfig[referenceUri].storeType === StoreType.Cloud) {
				return CloudPrimaryTokenService.getInstance();
			} else {
				return new OnPremPrimaryTokenService(
					networkLocation,
					storeConfig[referenceUri].storeType
				);
			}
		}
	}

	static getSecondaryTokenServiceInstance(
		referenceUri: string
	): SecondaryTokenServiceBase {
		if (!config.isUnifiedAuthenticationEnabled) {
			return CloudSecondaryTokenService.getInstance();
		} else {
			const storeConfig = AuthMan.getInstance().getStoreConfiguration();
			if (storeConfig[referenceUri].storeType === StoreType.Cloud) {
				return CloudSecondaryTokenService.getInstance();
			}

			return OnPremSecondaryTokenService.getInstance();
		}
	}
}
